( function ( _s ) {
	_s.fn.filterTags = function () {
		return this.each( el => {
			const _self = _s( el );
			const _filterTagsContainer = _self.find( '.filter-tags-container' );
			const filtersId = _self.attr( 'filters-id' );
			const _filters = filtersId ? _s( '#' + filtersId ) : false;
			const _clearSelection = _self.find( 'span.clear-selection' );
			const urlParameters = JSON.parse( _self.attr( 'url-parameters' ) || '{}' );
			const tagsList = [];

			const isEmpty = () => {
				return ! _filterTagsContainer.find( '.filter-tag' ).length;
			};

			const clearTag = _tag => {
				const filterData = {
					filter: _tag.attr( 'filter' ),
					filterOptionValue: _tag.attr( 'filter-option-value' ),
				};

				_filters.trigger( 'sp:remove-filter', filterData );

				removeTag( filterData );
			};

			const clearTags = () => {
				_filterTagsContainer.find( '.filter-tag' ).each( tag => {
					clearTag( _s( tag ) );
				} );
			};

			const addTag = filterData => {
				if (
					filterData.filter &&
					filterData.filterOptionLabel &&
					filterData.filterOptionValue
				) {
					const newTag = `<span class="filter-tag d-flex flex-row" filter="${ filterData.filter }" filter-option-value="${ filterData.filterOptionValue }" aria-label="${ filterData.filterOptionLabel }" title="${ filterData.filterOptionLabel }"><span class="filter-tag-label">${ filterData.filterOptionLabel }</span><span class="remove-tag" tabindex="0"></span></span>`;
					_clearSelection.before( newTag );
					_self.removeClass( 'empty' );
					updateTagsList( filterData, true );
				}
			};

			const removeTag = filterData => {
				if ( filterData.filter && filterData.filterOptionValue ) {
					const _tagToRemove = _filterTagsContainer.find(
						`.filter-tag[filter="${ filterData.filter }"][filter-option-value="${ filterData.filterOptionValue }"]`
					);

					if ( _tagToRemove.length ) {
						_tagToRemove.remove();
						_self.toggleClass( 'empty', isEmpty() );
						updateTagsList( filterData, false );
					}
				}
			};

			const removeTagByFilterName = filterData => {
				if ( filterData.filter ) {
					const _tagToRemove = _filterTagsContainer.find(
						`.filter-tag[filter="${ filterData.filter }"]`
					);

					if ( _tagToRemove.length ) {
						_tagToRemove.remove();
						_self.toggleClass( 'empty', isEmpty() );
						updateTagsList( filterData, false );
					}
				}
			};

			const updateTagsList = ( tag, add ) => {
				if ( add ) {
					tagsList.push( tag );
				} else {
					/**
					 * If no option value provided, target the tag to remove only by name.
					 */
					const tagIndex = ! tag.filterOptionValue
						? tagsList.findIndex( currentTag => currentTag.filter === tag.filter )
						: tagsList.findIndex(
								currentTag =>
									currentTag.filter === tag.filter &&
									currentTag.filterOptionValue === tag.filterOptionValue
						  );

					if ( tagIndex >= 0 ) tagsList.splice( tagIndex, 1 );
				}
			};

			const modifyTag = tag => {
				const _tagElement = _filterTagsContainer.find(
					`.filter-tag[filter="${ tag.filter }"]`
				);

				if ( _tagElement.length ) {
					_tagElement.attr( 'filter-option-value', tag.filterOptionValue );
					_tagElement.find( '.filter-tag-label' ).text( tag.filterOptionLabel );
				}
			};

			const updateDropdownFilterTags = ( filter, selectedOptions, isMultiple ) => {
				if ( isMultiple ) {
					selectedOptions.forEach( option => {
						// prettier-ignore
						if( ! tagsList.find( tag => tag.filter === option.filter && tag.filterOptionValue === option.filterOptionValue ) ){
                            addTag( option );
                        }
					} );

					tagsList
						.filter( tag => tag.filter === filter )
						.forEach( filterTag => {
							// prettier-ignore
							if ( ! selectedOptions.find( option => option.filter === filterTag.filter && option.filterOptionValue === filterTag.filterOptionValue ) ) {
                                removeTag( filterTag );
                            }
						} );
				} else {
					selectedOptions.forEach( option => {
						tagsList
							.filter( tag => tag.filter === option.filter )
							.forEach( tagToRemove => {
								removeTag( tagToRemove );
							} );

						/** Do not add the tag if selected option is default */

						const isDefault = _filters.find(
							`[name="${ filter }"] option[value="${ option.filterOptionValue }"][data-default]`
						).length;

						if ( ! isDefault ) addTag( option );
					} );
				}
			};

			const updateInputFilterTags = filter => {
				const filterData = {
					filter: filter.name,
					filterOptionValue: filter.value,
				};

				switch ( filter.type ) {
					case 'checkbox':
						filterData.filterOptionLabel = filter.getAttribute( 'filter-label' );
						if ( filter.checked ) {
							addTag( filterData );
						} else {
							removeTag( filterData );
						}
						break;
					case 'text':
						filterData.filterOptionLabel = filter.value;

						if ( filter.value.length ) {
							// prettier-ignore
							if ( tagsList.filter( tag => tag.filter === filter.name ).length ) {
								modifyTag( filterData );
								return;
							}
							addTag( filterData );
						} else {
							removeTagByFilterName( filterData );
						}

						break;
				}
			};

			_self.on( 'click', e => {
				const _target = _s( e.target ).hasClass( 'filter-tag' )
					? _s( e.target )
					: _s( e.target ).closest( '.filter-tag' );
				if ( _target.length ) {
					clearTag( _target );
				}
			} );

			_self.on( 'keyup', e => {
				// prettier-ignore
				if ( e.target.classList.contains( 'remove-tag' ) && (window.isEventKeyEnter(e) || window.isEventKeySpaceBar(e)) ) {
					clearTag(_s( e.target ).closest( '.filter-tag' ));
				}
			} );

			_clearSelection.on( 'click', () => {
				clearTags();
			} );

			_clearSelection.on( 'keyup', e => {
				if ( window.isEventKeyEnter( e ) || window.isEventKeySpaceBar( e ) ) {
					clearTags();
				}
			} );

			_filters.on( 'sp:filters-changed', e => {
				const filter = e.detail.target;
				const _filter = _s( filter );

				if ( _filter.length ) {
					switch ( filter.tagName.toLowerCase() ) {
						case 'select':
							updateDropdownFilterTags(
								filter.name,
								Array.from( filter.selectedOptions ).map( option => {
									return {
										filter: filter.name,
										filterOptionValue: option.value,
										filterOptionLabel: option.innerText,
									};
								} ),
								filter.hasAttribute( 'multiple' )
							);
							break;
						case 'input':
							updateInputFilterTags( filter );
							break;
					}
				}
			} );

			/** Add tags from URL parameters */
			Object.entries( urlParameters ).forEach( ( [ key, value ] ) => {
				const _filter = _filters.find( `[name="${ key }"]` );

				if ( _filter.length ) {
					const filter = _filter.firstElement();

					switch ( filter.tagName.toLowerCase() ) {
						case 'select': {
							const dropdownOptions = filter.hasAttribute( 'multiple' )
								? value
								: [ value ];

							dropdownOptions.forEach( currentValue => {
								const _option = _filter.find( `option[value="${ currentValue }"]` );
								const currentValueLabel = _option.text();

								/** Only add tag if it's not default option */
								if (
									currentValueLabel &&
									! _option.filter( '[data-default]' ).length
								) {
									addTag( {
										filter: key,
										filterOptionValue: currentValue,
										filterOptionLabel: currentValueLabel,
									} );
								}
							} );
							break;
						}
						case 'input': {
							if ( filter.type === 'text' ) {
								addTag( {
									filter: key,
									filterOptionValue: value,
									filterOptionLabel: value,
								} );
							} else if ( filter.type === 'checkbox' ) {
								value.forEach( currentValue => {
									const _checkBox = _filters.find(
										`[name="${ key }"][value="${ currentValue }"]`
									);

									if ( _checkBox.length ) {
										addTag( {
											filter: key,
											filterOptionValue: currentValue,
											filterOptionLabel: _checkBox.attr( 'filter-label' ),
										} );
									}
								} );
							}
							break;
						}
					}
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		const _filterTags = _s( '.filter-tags' );
		if ( _filterTags.length ) {
			_filterTags.filterTags();
		}
	} );
} )( window._s );
